





































































































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import {
  getMasterConstructionTask,
  getOperatorFilterOptions
} from "@/servicetask/api/service-schedule-list-api";
import { getAllClients } from "@/api/client-api";
import {
  ServiceTaskType,
  getServiceTaskTypes
} from "@/servicetask/api/service-tasks-api";

export interface SearchScheduleBarFormData {
  client?: string;
  operator?: string;
  constructionTask?: string;
  mobile?: string;
  selectedWeekDisplay: string;
}

@Component({})
export default class SearchScheduleBar extends Vue {
  @Prop({ required: true }) serviceTaskTypeId!: number;
  @Prop({ default: () => {} }) defaultQuery!: SearchScheduleBarFormData;
  @Prop() onMobile?: string;

  clientOptions: SelectOption[] = [];
  operatorOptions: SelectOption[] = [];
  constructionTaskOptions: SelectOption[] = [];
  taskTypeOptions: { text: string; value: string }[] = [];
  weekDisplayOptions: { value: string; text: string }[] = [
    { value: "1", text: "1 週間" },
    { value: "2", text: "2 週間" }
  ];

  query: SearchScheduleBarFormData = {
    client: "",
    operator: "",
    constructionTask: "",
    mobile: this.onMobile,
    selectedWeekDisplay: "1"
  };

  public created() {
    this.initServiceTaskTypes();
  }

  @Watch("defaultQuery", { immediate: true })
  onDefaultValuesChanged() {
    this.query = { ...this.query, ...this.defaultQuery };
  }

  @Watch("serviceTaskTypeId", { immediate: true })
  onServiceTaskTypeChanged() {
    this.initOptions();
  }

  search() {
    this.$emit("search", this.query);
  }

  initOptions(): void {
    this.getClientOptions().then(options => {
      this.clientOptions = [
        {
          text: "すべての発注者",
          value: ""
        }
      ].concat(options);
    });
    // 工程表に使用されている施工者だけをオプションとして取得する
    getOperatorFilterOptions({
      serviceTaskTypeId: String(this.serviceTaskTypeId)
    }).then(options => {
      this.operatorOptions = [
        {
          text: "すべての施工者",
          value: ""
        }
      ].concat(options);
    });
    this.getConstructionTaskOptions().then(options => {
      this.constructionTaskOptions = [
        {
          text: "すべてのタスク",
          value: ""
        },
        {
          text: "未完了",
          value: "-1"
        }
      ].concat(options);
    });
  }

  async getClientOptions(): Promise<SelectOption[]> {
    return (await getAllClients()).map(c => ({
      text: c.name,
      value: String(c.id)
    }));
  }

  async getConstructionTaskOptions(): Promise<SelectOption[]> {
    return (await getMasterConstructionTask(
      String(this.serviceTaskTypeId)
    )).map(
      // TODO 型をつける
      (c: any) => ({
        text: c.name,
        value: String(c.id)
      })
    );
  }

  get permissions() {
    return this.$store.getters.user.permissions;
  }

  get user() {
    return this.$store.state.user;
  }

  get canViewAllServiceTasks(): boolean {
    return this.permissions.length || this.user.canViewAllUninvitedProjects;
  }

  onChangeServiceIds() {
    //@ts-ignore
    if (window.FlutterChannel) {
      //@ts-ignore
      window.FlutterChannel.postMessage(
        JSON.stringify({
          event: "CHANGE_SERVICE_ID",
          data: this.serviceTaskTypeId
        })
      );
    }
  }

  private async initServiceTaskTypes() {
    try {
      this.taskTypeOptions = (await getServiceTaskTypes()).map(
        (serviceId: ServiceTaskType) => ({
          text: serviceId.name,
          value: String(serviceId.id)
        })
      );
    } catch (error) {
      // No handling
    }
  }

  private async changTaskTypeId() {
    this.$emit("search", this.query);
    this.onChangeServiceIds();
    this.$router.push({
      params: { serviceTaskTypeId: this.serviceTaskTypeId.toString() },
      query: this.$route.query
    });
  }
}
